import { Spin } from 'antd'
import React from 'react'
import { Icon } from './logo'

function Loading() {
  return (
    <Spin size='large' fullscreen indicator={<Icon />} />
  )
}

export default Loading